import { AppData } from '../types'

const STORAGE_KEY = 'zapiis_data'

export const initialData: AppData = {
  incidents: [],
  people: [],
  evidence: [],
  checkins: [],
  profile: {
    name: '',
    email: '',
    phone: '',
    caseDescription: '',
  },
  intakeAnswers: {
    outcome: '',
    timeline: '',
    context: '',
    reporting: '',
    impact: '',
    witnesses: '',
    additional: '',
    lastUpdated: '',
  },
  safetyChecks: [],
  hasAcceptedDisclaimer: false,
}

export const getStoredData = (): AppData => {
  try {
    const data = localStorage.getItem(STORAGE_KEY)
    return data ? JSON.parse(data) : initialData
  } catch (error) {
    console.error('Error reading from localStorage', error)
    return initialData
  }
}

export const saveStoredData = (data: AppData): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch (error) {
    console.error('Error saving to localStorage', error)
  }
}

export const clearStoredData = (): void => {
  localStorage.removeItem(STORAGE_KEY)
}
